import { Headline, Text } from '@oneaudi/unified-web-alpha-components';
import ConsumptionFootnote from '~/app/compositions/content/calculation-info/components/consumption-footnote';
import { FooterCarlineStyle } from '~/app/compositions/content/service-footer/components/user-marketing/styles/footer-carline-style';
import { useMarketConfig } from '~/app/market-config';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { DATA_TEST_ID } from '~/test/data-test-id';

export function FooterCarline() {
	const {
		catalog: { carInfo },
	} = useConfigurator();
	const carline = carInfo?.carline ?? 'Carline';
	const model = carInfo?.model ?? 'Model';
	const { config } = useMarketConfig();

	return (
		<FooterCarlineStyle data-testid={DATA_TEST_ID.CAR_TITLE}>
			<div>
				<Headline tag={'h3'} variant={{ type: 'display', order: '1' }} className="headline__main">
					{carline}
				</Headline>
				<Text tag="p" className="headline__sub">
					{model}
					{!config.hideConsumptionEmissionEngineName && <ConsumptionFootnote />}
				</Text>
			</div>
		</FooterCarlineStyle>
	);
}
